import { Button } from '@progress/kendo-react-buttons';
import { TextBox } from '@progress/kendo-react-inputs';
import React from 'react';
import { CogOutline } from '../../../icons/icons';
import AirportSummary from '../../features/home/flyouts/AirportSummary';
import { PanelTitleTrailingContent } from '../../features/home/panels/HomePanel';
import { useAppDispatch } from '../../hooks/store-hooks';
import { updatePanelInWindow, WorkspaceWindowPanelState } from '../../state/slices/workspace-slice';

export function AirportSummaryExternalWrapper(props: { windowId: number; panel: WorkspaceWindowPanelState }) {
    const dispatch = useAppDispatch();
    const displayAirportId = props.panel.airportId;
    const [showSettings, setShowSettings] = React.useState(!displayAirportId);
    const [editAirportId, setEditAirportId] = React.useState(displayAirportId);

    return (
        <div className="position-relative h-100">
            <PanelTitleTrailingContent>
                <Button
                    title="Change airport"
                    svgIcon={CogOutline}
                    fillMode="flat"
                    className="button-small"
                    onClick={() => setShowSettings(true)}
                />
            </PanelTitleTrailingContent>

            {displayAirportId && <AirportSummary id={displayAirportId} />}

            {showSettings && (
                <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(0,0,0,0.18)' }}>
                    <div className="d-flex h-100 align-items-center justify-content-center">
                        <div className="k-card p-2">
                            <div>Airport ID</div>
                            <TextBox value={editAirportId} onChange={(e) => setEditAirportId((e.value as string).toUpperCase())} />
                            <div className="d-flex gap-2 pt-2">
                                <Button
                                    className="flex-grow-1"
                                    style={{ flexBasis: 0 }}
                                    themeColor="primary"
                                    onClick={() => {
                                        dispatch(
                                            updatePanelInWindow({
                                                windowId: props.windowId,
                                                update: {
                                                    id: props.panel.id,
                                                    airportId: editAirportId
                                                }
                                            })
                                        );
                                        setShowSettings(false);
                                    }}>
                                    Ok
                                </Button>
                                <Button className="flex-grow-1" style={{ flexBasis: 0 }} onClick={() => setShowSettings(false)}>
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
